import React, { useContext } from "react";
import { Box, List, ListItem, Typography } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import DataDuoIcon from "../../../../../assets/summary/DataDuo.svg";
import IdFrontIcon from "../../../../../assets/summary/IdFront.svg";
import UploadFile from "../../../../../assets/summary/UploadFile.svg";
import { useTheme } from "@material-ui/styles";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { CustomRegistry } from "@nemuru-eng/js-api-client";

export default function Slide3({ isScreenXs, onBoardingByBorrower }) {
  const { palette } = useTheme();
  const {
    state: { registry },
  } = useContext(ConfigContext);

  return (
    <Box
      mt={3}
      mx={2}
      className={"appear-anim"}
      display={"flex"}
      justifyContent={"flex-start"}
      flexDirection={"column"}
      gridGap={24}
    >
      <Box mb={2}>
        <Box display="flex" justifyContent="center" mb={2}>
          <Typography
            align="center"
            variant={isScreenXs ? "h5" : "h4"}
            style={{ color: palette.text.title }}
          >
            <strong>
              <Text tId="WHAT_WILL_YOU_NEED" />
            </strong>
          </Typography>
        </Box>
        <Typography
          align="center"
          variant={"subtitle1"}
          style={{
            color: palette.text.title,
            lineHeight: "1.4",
            marginTop: "0.25rem",
          }}
        >
          <strong>
            <Text tId="DOCUMENT_RECOMMENDATION" />
          </strong>
        </Typography>
      </Box>
      <Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent={"flex-start"}
        >
          <List>
            <ListItem
              style={{
                alignItems: "start",
                padding: 0,
              }}
            >
              <img
                src={IdFrontIcon}
                height="50px"
                alt="image for valid document id"
              />
              <Box ml={3}>
                <Typography
                  variant={isScreenXs ? "subtitle2" : "subtitle1"}
                  style={{ color: palette.text.title }}
                >
                  <strong>
                    <Text tId="DNI_OR_NIE" />
                  </strong>
                </Typography>
                <Typography
                  variant={"body2"}
                  style={{ color: palette.text.primary }}
                >
                  <Text tId="NIE_EU_PASSPORT" />
                </Typography>
              </Box>
            </ListItem>
          </List>
        </Box>
        <Box>
          <List>
            <ListItem
              style={{
                alignItems: "start",
                padding: 0,
              }}
            >
              <img
                src={DataDuoIcon}
                height="50px"
                alt="image for bank account"
              />
              <Box ml={3}>
                <Typography
                  variant={isScreenXs ? "subtitle2" : "subtitle1"}
                  style={{ color: palette.text.title }}
                >
                  <strong>
                    {onBoardingByBorrower ? (
                      <Text tId="SPANISH_ACCOUNT" />
                    ) : (
                      <Text tId="INCOME" />
                    )}
                  </strong>
                </Typography>
                <Typography
                  variant={"body2"}
                  style={{ color: palette.text.primary }}
                >
                  <Text tId="SPANISH_ACCOUNT_DETAIL" />
                </Typography>
              </Box>
            </ListItem>
          </List>
        </Box>
        {registry === CustomRegistry.CAIXABANK && (
          <Box flex={0.7}>
            <List>
              <ListItem
                style={{
                  alignItems: "start",
                  padding: 0,
                }}
              >
                <img
                  src={UploadFile}
                  height="50px"
                  alt="image for upload file"
                />
                <Box ml={3}>
                  <Typography
                    variant={isScreenXs ? "subtitle2" : "subtitle1"}
                    style={{ color: palette.text.title }}
                  >
                    <strong>
                      <Text tId="OTHER_DOCUMENTS" />
                    </strong>
                  </Typography>
                  <Typography
                    variant={"body2"}
                    style={{ color: palette.text.primary }}
                  >
                    <Text tId="OTHER_DOCUMENTS_DETAIL" />
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </Box>
        )}
      </Box>
    </Box>
  );
}
